export default __webpack_public_path__ + "static/media/OpenSans.bc27794c.eot";